import { Component, OnInit } from '@angular/core';
import { environment } from './../../../../environments/environment';

@Component({
  	selector: 'app-toolcards-phrase-challenges',
  	templateUrl: './toolcards-phrase-challenges.component.html',
  	styleUrls: ['./toolcards-phrase-challenges.component.scss']
})
export class ToolcardsPhraseChallengesComponent implements OnInit {
	public env;

  	constructor() { }

  	ngOnInit() {
  		this.env=environment;
  	}

}
